<template>
    <div class="header-apr">
        <Tables ref="tableInqueryApr"
            :columns="colunas"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            :newHeaderStatus="true"
            v-on:Load="onLoad"
            style="font-family: 'Segoe UI'; font-size: 14px">
            <tr v-for="(obj,index) in listaApr" :key="index">
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoAtividade"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.local !== null ? obj.local : 'N/D' "></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.refereciaObra !== null ? obj.refereciaObra : 'N/D' "></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :newState="true" :colorStatus="obj.colorBackgroundStatusApr" :descriptionNewStatus="obj.statusAPRDescricao" :fontColorStatus="obj.colorFontStatusApr" style="font-weight: bold;"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.responsavel"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.dataExecucaoAPRformat"></TableColumn>
                <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.dataValidadeAPRformat"></TableColumn>
                <TableColumn :IsDocumentActions="true"
                    :HasDownload="true"
                    :HasDetails="false"
                    :HasDocumentDelete="false"
                    style="justify-content: center;display: flex; color: #008144;"
                    v-on:Download="generatePDF(obj)"
                    ></TableColumn>
            </tr>
        </Tables>
        <vue-html2pdf
        :show-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1200"
        :filename= "nomeArquivo"
        :pdf-quality="2"
        :manual-pagination="true"
        pdf-format="a4"
        :pdf-margin="10"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @beforeDownload="abrirNovaGuia"
        ref="html2Pdf">
        <section slot="pdf-content">
          <div class="container-pdf">
          <div class="title-template">
            <div class="info-pdf w-100">
              <div class="numberApr w-75">
                <div class="iconHat mr-2">
                  <i class="fas fa-hard-hat m-2" style="color:#008144"></i>
                </div>
                <div class="titleNumberApr" style="font-size: 14px">{{ aprSelected.codigoAtividade }} ({{ aprSelected.atividade }})</div>
              </div>
              <div class="numbreRevisao w-25">
                <div class="font-title mr-2">Revisão:</div>
                <div class="revisao">{{ aprSelected.revisao }}</div>
              </div>
            </div>
            <div class="dateResponsable w-100">
              <div class="dateApr w-30">
                <div class="font-title mr-2">Data:</div>
                <div class="font-info">{{ aprSelected.dataExecucaoFormatada }}</div>
              </div>
              <div class="dateExpire w-30">
                <div class="font-title mr-2">Vencimento:</div>
                <div class="font-info"> {{ aprSelected.dataValidadeAPRFormatada }}</div>
              </div>
            </div>
            <div class="addressApr">
              <div class="addressDiv w-100">
                <div class="font-title mr-2">Responsável:</div>
                <div class="font-info"> {{ aprSelected.responsavel }} </div>
              </div>
            </div>
            <div v-if="nameClient" class="addressApr">
              <div class="addressDiv w-100">
                <div class="font-title mr-2">Cliente:</div>
                <div class="font-info">{{ nameClient }}</div>
              </div>
            </div>
            <!-- <div class="dateResponsable w-100">
              <div class="dateApr w-30">
                <div class="font-title mr-2">Elaborador:</div>
                <div class="font-info"> {{ aprSelected.elaborador }} </div>
              </div>
              <div class="dateApr w-30">
                <div class="font-title mr-2">Aprovador:</div>
                <div class="font-info"> {{ aprSelected.aprovador }}</div>
              </div>
            </div> -->
            <div class="dateResponsable w-100">
              <div class="dateApr w-30">
                <div class="font-title mr-2">Código da Obra:</div>
                <div class="font-info"> {{ aprSelected.refereciaObra }} </div>
              </div>
              <div class="dateApr w-30">
                <div class="font-title mr-2">Nome da Obra/Setor:</div>
                <div class="font-info"> {{ aprSelected.local }}</div>
              </div>
            </div>
            <!-- <div class="addressApr" v-if="aprSelected.cidade != 'N/D'  || aprSelected.estado != 'N/D' || aprSelected.endereco != 'N/D' || aprSelected.numero != 'N/D'">
              <div class="addressDiv w-100">
                <div class="font-title mr-2">Endereço:</div>
                <div class="font-info"> {{ aprSelected.cidade + '-' + aprSelected.estado + ', ' + aprSelected.endereco + ' - ' + aprSelected.numero  }} </div>
              </div>
            </div> -->
            <div class="addressApr" v-if="aprSelected.observacao != ''">
              <div class="addressDiv w-100">
                <div class="font-title mr-2">Observação:</div>
                <div class="font-info"> {{ aprSelected.observacao  }} </div>
              </div>
            </div>
          </div>
          <div class="analysis-template">
            <div class="title-risk mb-2">
              MATRIZ DE ANÁLISE DE RISCO
            </div>
            <div class="analysisRisk mb-2">
              <div class="lfAnalysis w-100">
                <div class="font-title mr-2 mb-2">MATRIZ ANÁLISE DE RISCO:</div>
                <div class="statusTemplate"
                  :style="{'color': aprSelected.colorFontStatusApr}">
                      {{ aprSelected.statusAPRDescricao }}
                    </div>
              </div>
            </div>
            <hr>
            <div class="analysisRiskItens mb-2" style="break-inside: avoid;"  v-if="lisEPIPDF.length !== 0">
              <div class="title-risk mb-2" v-if="lisEPIPDF.length !== 0">EPI</div>
              <div class="lfAnalysisItens w-100">
                <div class="statusTemplate" style="padding: 0.5rem; break-inside: avoid;" v-for=" (obj,index) in lisEPIPDF" :key="index">
                      {{ obj.nomeEPI }}
                </div>
              </div>
            </div>

            <div class="analysisRiskItens mb-2" style="break-inside: avoid;" v-if="lisFerramentasPDF.length !== 0">
              <div class="title-risk mb-2" v-if="lisFerramentasPDF.length !== 0">FERRAMENTAS</div>
              <div class="lfAnalysisItens w-100">
                <div class="statusTemplate" style="padding: 0.5rem; break-inside: avoid;" v-for=" (obj,index) in lisFerramentasPDF" :key="index">
                      {{ obj.nomeFerramentas }}
                </div>
              </div>
            </div>

            <div class="analysisRiskItens mb-2" style="break-inside: avoid;" v-if="lisRiscosEspeciaisPDF.length !== 0">
              <div class="title-risk mb-2" v-if="lisRiscosEspeciaisPDF.length !== 0">RISCOS ESPECIAIS</div>
              <div class="lfAnalysisItens w-100">
                <div class="statusTemplate" style="padding: 0.5rem; break-inside: avoid;" v-for=" (obj,index) in lisRiscosEspeciaisPDF" :key="index">
                      {{ obj.nomeRiscosEspecial }}
                </div>
              </div>
            </div>

            <div class="analysisRiskItens mb-2" style="break-inside: avoid;"  v-if="lisCursosNRPDF.length !== 0">
              <div class="title-risk mb-2" v-if="lisFerramentasPDF.length !== 0">CURSOS NR</div>
              <div class="lfAnalysisItens w-100">
                <div class="statusTemplate" style="padding: 0.5rem; break-inside: avoid;" v-for=" (obj,index) in lisCursosNRPDF" :key="index">
                      {{ obj.nomeCursosNr }}
                </div>
              </div>
            </div>

            <div class="mb-2">
              <div class="title-checklist">
                AVALIAÇÃO
              </div>
              <div class="checklist">
                <detailsApr ref="detailsApr" :isPdf="true" :propApr="propApr"></detailsApr>
              </div>
            </div>
            <hr v-if="listMidia.length !== 0">
            <div class="mb-2" style="break-inside: avoid;" v-if="listMidia.length !== 0">
              <div class="title-medias">MÍDIAS</div>
              <mediasApr ref="mediaApr" :isPdf="true" :listMidia="listMidia"></mediasApr>
            </div>
            <hr>
            <div class="signaturelists">
              <div class="title-signature mb-2 w-100">ASSINATURAS</div>
                  <div class="container_ocorrencias_filtradas">
                    <div class="numero_oce font">Mátricula</div>
                    <div class="tecnico_oce font">Responsável</div>
                    <div class="engenheiro_oce font">Cargo</div>
                    <div class="causa_raiza font">Assinatura</div>
                  </div>
                  <div class="container_ocorrencias w-100 mb-2" v-for=" (obj,index) in assinaturaList" :key="index">
                    <div class="numero_oce_result font_result w-25">{{obj.matricula !== null ? obj.matricula : obj.documentoAssinatura}}</div>
                    <div class="tecnico_oce_result font_result w-25">{{obj.nomeFuncionario !== null ? obj.nomeFuncionario : obj.nomeAssinatura}}</div>
                    <div class="engenheiro_oce_result font_result w-25">{{obj.liderDescricao !== null ? obj.liderDescricao : 'N/D'}}</div>
                    <div class="causa_raiza_result w-25">
                      <img class="icone-img"  :src="`${`data:image/${obj.extensao}`};base64,`+ obj.img64"/>
                    </div>
                </div>
            </div>
            <div class="signaturelists" style="display: flex; align-items: center; width: 100%; gap: 2rem; margin-top: 2rem;">
               <div class="container_assinaturas">
                  <div class="container_img_assinatura">
                    <img
                      v-if="signatureResponsable"
                      class="img_assinatura"
                      :src="`data:image/${signatureResponsableExtension};base64,${signatureResponsable}`"
                    />
                  </div>
                  <div class="border-assinatura"></div>
                  <div class="nome_assinatura">Responsável pela Atividade </div>
               </div>
               <div class="container_assinaturas">
                  <div class="container_img_assinatura">
                    <img
                      v-if="signatureTechnical"
                      class="img_assinatura"
                      :src="`data:image/${signatureTechnicalExtension};base64,${signatureTechnical}`"
                    />
                  </div>
                  <div class="border-assinatura"></div>
                  <div class="nome_assinatura">Segurança do Trabalho</div>
               </div>
               <div class="container_assinaturas">
                  <div class="container_img_assinatura">
                    <img
                      v-if="signatureClient"
                      class="img_assinatura"
                      :src="`data:image/${signatureClientExtension};base64,${signatureClient}`"
                    />
                  </div>
                  <div class="border-assinatura"></div>
                  <div class="nome_assinatura">Cliente</div>
               </div>
            </div>
            <div class="signaturelists" style="display: flex; justify-content: center; align-items: center; width: 100%;">
              <img class="img_matriz" :src="matrizRisco">
            </div>
            <div class="assinatura-bloco-final">
              <div class="coluna-esquerda">
                <div><strong>Elaborador:</strong> {{ aprSelected.elaborador }}</div>
                <div><strong>Data:</strong> {{ new Date(aprSelected.dataElaboracao).toLocaleDateString('pt-BR') || '---' }}</div>
              </div>
              <div class="coluna-direita">
                <div><strong>Aprovador:</strong> {{ aprSelected.aprovador }}</div>
                <div><strong>Data:</strong> {{ new Date(aprSelected.dataAprovacao).toLocaleDateString('pt-BR') || '---' }}</div>
              </div>
            </div>
          </div>
        </div>
        </section>
      </vue-html2pdf>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import collapseApr from '@/views/private/apr/registerApr/components/collapseapr/collapseApr.vue'
import AprAnalisePreliminarRisco from '@/shared/http/repositories/business/aprInquery'
import { loading } from '@/shared/utils/UIHelper'
import VueHtml2pdf from 'vue-html2pdf'
import cabecalhoPng from '../../../../../../../static/img/realestate/relatorio/cabecalho.png'
import mediasApr from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/medias/components/mediaApr/mediaApr.vue'
import detailsApr from '@/views/private/apr/inqueryApr/components/inqueryTable/components/inqueryDetailsApr/components/inqueryDetailsTableApr/components/details/components/detailsApr.vue'
// import matriz from '../../../../../../../static/img/apr/matrizRisco.jpg'
import matriz from '../../../../../../../static/img/apr/matriz-de-risco.png'

export default {
  name: 'registerTable',
  mixins: [ActionsForm],
  components: {
    HeadDetailsGama,
    collapseApr,
    VueHtml2pdf,
    mediasApr,
    detailsApr
  },
  data () {
    return {
      colunas: ['CÓDIGO DA APR', 'ÁREA', 'OBRA', 'STATUS', 'RESPONSÁVEL', 'DATA APR', 'DATA VENCIMENTO', ''],
      listaApr: [],
      matrizRisco: matriz,
      formSearch: {},
      form: {
        categoria: null,
        descricao: null
      },
      isTechnical: false,
      nomeArquivo: '',
      dataFormatada: null,
      listMidia: [],
      lisEPIPDF: [],
      lisRiscosEspeciaisPDF: [],
      lisCursosNRPDF: [],
      dataRelatorio: null,
      dataInicioFormatado: null,
      dataFimFormatado: null,
      idPdf: false,
      propApr: null,
      assinaturaList: [],
      nameClient: null,
      nameTechnical: null,
      nameResponsable: null,
      signatureResponsable: '',
      signatureResponsableExtension: '',
      signatureTechnical: '',
      signatureTechnicalExtension: '',
      signatureClient: '',
      signatureClientExtension: '',
      lisFerramentasPDF: [],
      midiapdf: null,
      midiapdfList: [],
      aprSelected: {
        arquivoID: null,
        arquivoNome: '',
        atividade: '',
        cidade: '',
        codigoAtividade: '',
        colorBackgroundStatusApr: '',
        colorFontStatusApr: '',
        dataExecucaoAPR: null,
        dataExecucaoAPRFormatada: '',
        dataValidadeAPR: null,
        dataValidadeAPRFormatada: 'null',
        descricaoAtividade: '',
        endereco: '',
        estado: '',
        numero: '',
        id: null,
        local: '',
        matricula: null,
        obraid: null,
        offline: null,
        offlineDescricao: '',
        referenciaObra: '',
        responsavel: '',
        revisao: '',
        status: null,
        statuApr: null,
        statuaAPRDescricao: '',
        signatureResponsable: '',
        signatureResponsabletype: null,
        signatureTechnical: '',
        signatureTechnicaltype: null,
        signatureClient: '',
        signatureClienttype: null,
        type: null,
        elaborador: '',
        validador: ''
      }
      // type: null
    }
  },

  props: {
  },

  watch: {
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      this.GetAllApr()
    },
    onSelect (value) {
      this.$router.push(`/APR/Consulta/Detalhes?Detalhes=${value.id}`)
    },
    GetAllApr () {
      if (this.hasRole(this.roles.APR_RESEARCH_TECHNICIAN_VIEW)) {
        this.formSearch.isTechnical = true
      }

      if (this.hasRole(this.roles.APR_SEARCH_CONTROLLER_APPROVAL)) {
        this.formSearch.isTechnical = false
      }

      if (this.hasRole(this.roles.RW_REAL_ESTA_ADMIN)) {
        this.formSearch.isTechnical = false
      }
      loading.push()
      AprAnalisePreliminarRisco.GetAllApr(this.formSearch, this.$refs.tableInqueryApr.pagingLimit, this.$refs.tableInqueryApr.pagingIndex)
        .then(Response => {
          this.$refs.tableInqueryApr.LoadAllByData(Response)
          this.listaApr = Response.data.data
          loading.pop()
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    },
    dataFormatadaPdf () {
      var dataAtual = new Date()
      var ano = dataAtual.getFullYear()
      var mes = ('0' + (dataAtual.getMonth() + 1)).slice(-2)
      var dia = ('0' + dataAtual.getDate()).slice(-2)
      this.dataFormatada = dia + '/' + mes + '/' + ano
    },
    async generatePDF (obj) {
      let diaAtual = new Date()
      let dia = diaAtual.getDate() < 10 ? '0' + diaAtual.getDate() : diaAtual.getDate()
      let mes = diaAtual.getMonth() + 1
      if (mes < 10) {
        mes = '0' + mes
      }
      this.nomeArquivo = obj.codigoAtividade
      let ano = diaAtual.getFullYear()
      this.dataRelatorio = dia + '/' + mes + '/' + ano
      await this.getAprSelected(obj.id)
      await this.GetMedias(obj.id)
      await this.getSignaturesPdf(obj.id)
      await this.getSignatureResponsavel(obj.id)
      await this.getFerramentasPDF(obj.id)
      await this.getEPIPDF(obj.id)
      await this.getRiscosEspeciaisPDF(obj.id)
      await this.getCursosNRPDF(obj.id)
      this.aprSelected = {...this.propApr}
      await this.$refs['detailsApr'].onLoad()
      await this.$nextTick()
      await this.$refs.html2Pdf.generatePdf()
    },
    async abrirNovaGuia ({ html2pdf, options, pdfContent }) {
      const headerImage = new URL(cabecalhoPng, window.location.origin)
      const headerPdf = this.createImageHeaderFooter(headerImage.href)

      // if (this.signatureResponsable !== undefined) {
      //   var assResponsavel = `data:image/${this.signatureResponsableExtension};base64,${this.signatureResponsable}`
      // }
      // if (this.signatureTechnical !== undefined) {
      //   var assTecnico = `data:image/${this.signatureTechnicalExtension};base64,${this.signatureTechnical}`
      // }
      // if (this.signatureClient !== undefined) {
      //   var assClient = `data:image/${this.signatureClientExtension};base64,${this.signatureClient}`
      // }

      // const fixedWidth = 1.75
      // const fixedHeight = 0.5

      options.margin = [1.4, 0, 1.1, 0]

      await html2pdf()
        .set(options)
        .from(pdfContent)
        .toPdf()
        .get('pdf')
        .then((pdf) => {
          const totalPages = pdf.internal.getNumberOfPages()

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i)
            pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)
            pdf.setFillColor(28, 98, 40)
            pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
            pdf.setTextColor('#fff')
            pdf.setFont('Helvetica', 'bold')
            pdf.setFontSize(10)
            pdf.text(
              'Zopone - ' + this.aprSelected.codigoAtividade + ' - ' + this.dataRelatorio,
              0.5,
              pdf.internal.pageSize.getHeight() - 0.1
            )
            pdf.text('Pág ' + i + ' de ' + totalPages, 7.5, pdf.internal.pageSize.getHeight() - 0.1)

            // if (i === totalPages) {
            //   const signatureHeight = pdf.internal.pageSize.getHeight() - 2.7
            //   if (this.signatureResponsable !== undefined) {
            //     pdf.addImage(assResponsavel, this.signatureResponsableExtension, 0.5, signatureHeight, fixedWidth, fixedHeight)
            //   }
            //   if (this.signatureTechnical !== undefined) {
            //     pdf.addImage(assTecnico, this.signatureTechnicalExtension, 3.25, signatureHeight, fixedWidth, fixedHeight)
            //   }
            //   if (this.signatureClient !== undefined) {
            //     pdf.addImage(assClient, this.signatureClientExtension, 6, signatureHeight, fixedWidth, fixedHeight)
            //   }
            //   pdf.setLineWidth(0.0)
            //   pdf.setDrawColor(54, 54, 54)
            //   const lineHeight = pdf.internal.pageSize.getHeight() - 2.2
            //   pdf.line(0.25, lineHeight, 2.5, lineHeight)
            //   pdf.line(3, lineHeight, 5.25, lineHeight)

            //   pdf.setTextColor('#666')
            //   pdf.setFont('Helvetica', 'bold')
            //   pdf.text(
            //     'Responsável pela Atividade',
            //     0.5,
            //     pdf.internal.pageSize.getHeight() - 2
            //   )
            //   if (this.nameResponsable) {
            //     const nameResponsable = this.nameResponsable.trim()
            //     const wordCount = nameResponsable.split(/\s+/).length

            //     var spacing
            //     if (wordCount === 1) {
            //       spacing = 1.2
            //     } else if (wordCount === 2) {
            //       spacing = 0.9
            //     } else {
            //       spacing = 0.4
            //     }
            //     pdf.text(
            //       this.nameResponsable,
            //       spacing,
            //       pdf.internal.pageSize.getHeight() - 1.8
            //     )
            //   } else {
            //     pdf.text('', 6.20, pdf.internal.pageSize.getHeight() - 1.8)
            //   }
            //   pdf.text(
            //     'Segurança do Trabalho',
            //     3.35,
            //     pdf.internal.pageSize.getHeight() - 2
            //   )
            //   if (this.nameTechnical) {
            //     const nameResponsable = this.nameTechnical.trim()
            //     const wordCount = nameResponsable.split(/\s+/).length

            //     var spacingTec
            //     if (wordCount === 1) {
            //       spacingTec = 3.4
            //     } else if (wordCount === 2) {
            //       spacingTec = 3
            //     } else {
            //       spacingTec = 2.9
            //     }
            //     pdf.text(
            //       this.nameTechnical,
            //       spacingTec,
            //       pdf.internal.pageSize.getHeight() - 1.8
            //     )
            //   } else {
            //     pdf.text('', 6.20, pdf.internal.pageSize.getHeight() - 1.8)
            //   }
            //   if (assClient !== null || assClient !== undefined) {
            //     pdf.line(5.75, lineHeight, 8, lineHeight)
            //     pdf.text(
            //       'Cliente',
            //       6.65,
            //       pdf.internal.pageSize.getHeight() - 2
            //     )
            //     if (this.nameClient) {
            //       const nameResponsable = this.nameClient.trim()
            //       const wordCount = nameResponsable.split(/\s+/).length

            //       var spacingClie
            //       if (wordCount === 1) {
            //         spacingClie = 6.5
            //       } else if (wordCount === 2) {
            //         spacingClie = 6.3
            //       } else {
            //         spacingClie = 6.1
            //       }
            //       pdf.text(
            //         this.nameClient,
            //         spacingClie,
            //         pdf.internal.pageSize.getHeight() - 1.8
            //       )
            //     } else {
            //       pdf.text('', 6.20, pdf.internal.pageSize.getHeight() - 1.8)
            //     }
            //   }

            //   const legendasSeveidade = `I - Desprezível II - Marginal III - Crítica IV - Catastrófica`
            //   const legendasProbabilidade = `A - Extremamente Remoto B - Remoto C - Pouco Provável D - Provável E - Frequente`

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#1d1d1d')
            //   pdf.text('Legendas', 0.3, pdf.internal.pageSize.getHeight() - 1.5)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#1d1d1d')
            //   pdf.text('Severidade (S):', 0.3, pdf.internal.pageSize.getHeight() - 1.2)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#575757')
            //   pdf.text(legendasSeveidade, 1.4, pdf.internal.pageSize.getHeight() - 1.2)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#1d1d1d')
            //   pdf.text('Probabilidade (P):', 0.3, pdf.internal.pageSize.getHeight() - 0.9)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#575757')
            //   pdf.text(legendasProbabilidade, 1.6, pdf.internal.pageSize.getHeight() - 0.9)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor('#1d1d1d')
            //   pdf.text('Categoria de Risco (CR):', 0.3, pdf.internal.pageSize.getHeight() - 0.6)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor(28, 98, 40) // Verde para "T - Tolerável"
            //   pdf.text('T - Tolerável', 2, pdf.internal.pageSize.getHeight() - 0.6)

            //   pdf.setFontSize(10)
            //   pdf.setTextColor(188, 72, 7) // Verde para "T - Tolerável"
            //   pdf.text('M - Moderado', 2.9, pdf.internal.pageSize.getHeight() - 0.6)

            //   pdf.setTextColor(140, 23, 23) // Vermelho para "NT - Não Tolerável"
            //   pdf.text('NT - Não Tolerável', 3.9, pdf.internal.pageSize.getHeight() - 0.6)

            //   // pdf.addPage()
            //   // Adicionar as legendas no PDF
            //   // const headerPdf = this.createImageHeaderFooter(headerImage.href)
            //   // pdf.addImage(headerPdf, 'PNG', 0, 0, 8.5, 0)

            //   // const legendas = `
            //   // Legendas

            //   // Severidade (S)
            //   // I   - Desprezível
            //   // II  - Marginal
            //   // III - Crítica
            //   // IV  - Catastrófica

            //   // Probabilidade (P)
            //   // A - Extremamente Remoto
            //   // B - Remoto
            //   // C - Pouco Provável
            //   // D - Provável
            //   // E - Frequente

            //   // Categoria de Risco (CR)
            //   // `

            //   // // Definindo o espaçamento para as legendas

            //   // // Adicionando as legendas no PDF
            //   // pdf.setFontSize(10)
            //   // pdf.setTextColor('#424242')
            //   // pdf.text(legendas, 2.5, pdf.internal.pageSize.getHeight() - 10)

            //   // // Definir cores específicas para cada Categoria de Risco (CR)
            //   // pdf.setFontSize(10)
            //   // pdf.setTextColor(28, 98, 40) // Verde para "T - Tolerável"
            //   // pdf.text(' T - Tolerável', 3, pdf.internal.pageSize.getHeight() - 7.2)

            //   // pdf.setTextColor(188, 72, 7) // Laranja para "M - Moderado"
            //   // pdf.text(' M - Moderado', 3, pdf.internal.pageSize.getHeight() - 7)

            //   // pdf.setTextColor(140, 23, 23) // Vermelho para "NT - Não Tolerável"
            //   // pdf.text(' NT - Não Tolerável', 3, pdf.internal.pageSize.getHeight() - 6.8)

            //   // Rodapé também na última página
            //   // pdf.setFillColor(28, 98, 40)
            //   // pdf.rect(0, pdf.internal.pageSize.getHeight() - 0.3, pdf.internal.pageSize.getWidth(), 10, 'F')
            //   // pdf.setTextColor('#fff')
            //   // pdf.setFontSize(10)
            //   // pdf.text(
            //   //   'Zopone - ' + this.aprSelected.codigoAtividade + ' - ' + this.dataRelatorio,
            //   //   0.5,
            //   //   pdf.internal.pageSize.getHeight() - 0.1
            //   // )
            // }
          }
        })
        .save()
    },
    async getAprSelected (value) {
      this.propApr = null
      loading.push()
      await AprAnalisePreliminarRisco.GetAprSelected(value)
        .then(Response => {
          this.propApr = {...Response.data[0]}
          loading.pop()
        })
        .catch(err => {
          console.log(err)
          loading.pop()
        })
    },
    async GetMedias (value) {
      this.listMidia = []
      this.midiaVazia = false
      loading.push()
      await AprAnalisePreliminarRisco.GetAprMedia(value)
        .then(Response => {
          if (Response.data.data !== null) {
            this.midiaVazia = true
            this.listMidia = Response.data.data
            this.listMidia.forEach(item => {
              item.extensao = item.arquivoNome.split('.').pop()
            })
          }
          loading.pop()
        })
        .catch((err) => {
          loading.pop()
          console.log(err)
        })
    },
    createImageHeaderFooter (imgHref) {
      const img = document.createElement('img')
      img.src = imgHref
      img.style.border = 'none'
      return img
    },
    safeImgExt (arquivoNome) {
      // arquivoNome de assinatura é uma chave S3 sem extensão de arquivo — split('.').pop()
      // devolvia o caminho inteiro e gerava data:image/<caminho> inválido. Assinatura é PNG.
      const ext = (arquivoNome || '').split('.').pop().toLowerCase()
      return ['png', 'jpg', 'jpeg', 'webp', 'gif'].includes(ext) ? ext : 'png'
    },
    async getSignaturesPdf (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.getSignaturesPdf(aprId)
        .then(Response => {
          this.assinaturaList = Response.data.data
          this.assinaturaList.forEach(item => {
            item.extensao = this.safeImgExt(item.arquivoNome)
          })
          loading.pop()
        })
        .catch(err => {
          console.log(err)
        })
    },
    async getSignatureResponsavel (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetSignatureResponsavel(aprId)
        .then(Response => {
          loading.pop()
          this.listAssinaturaRes = Response.data.data
          this.listAssinaturaRes.forEach(item => {
            item.extensao = this.safeImgExt(item.arquivoNome)
            if (item.tipoExecutante === 1) {
              this.signatureResponsable = item.img64
              this.nameResponsable = item.externo === true ? item.nomeAssinatura : item.nomeFuncionario
              this.signatureResponsableExtension = item.extensao
            }
            if (item.tipoExecutante === 2) {
              this.signatureClient = item.img64
              this.nameClient = item.externo === true ? item.nomeAssinatura : item.nomeFuncionario
              this.signatureClientExtension = item.extensao
            }
            if (item.tipoExecutante === 3) {
              this.signatureTechnical = item.img64
              this.nameTechnical = item.externo === true ? item.nomeAssinatura : item.nomeFuncionario
              this.signatureTechnicalExtension = item.extensao
            }
          })
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getFerramentasPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetFerramentasByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.lisFerramentasPDF = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getEPIPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetEPIByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.lisEPIPDF = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getRiscosEspeciaisPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetRiscosEspeciaisByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.lisRiscosEspeciaisPDF = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    },
    async getCursosNRPDF (aprId) {
      loading.push()
      await AprAnalisePreliminarRisco.GetCursosNRByAPR(aprId)
        .then(Response => {
          loading.pop()
          this.lisCursosNRPDF = Response.data.data
        })
        .catch(err => {
          loading.pop()
          console.log(err)
        })
    }
  }
}

</script>

<style scoped>
.border-assinatura {
  width: 200px;
  border-bottom: 1px solid rgb(146, 146, 146);
}
.img_matriz {
  width: 80%;
}
.nome_assinatura{
  font-family: 'Segoe UI';
  font-size: 11px;
  width: 200px;
  display: flex;
  justify-content: center;
  text-align: center;
}
.img_assinatura {
  max-width: 200px;
  max-height: 70px;
  object-fit: contain;
  margin-bottom: 4px;
}
.container_assinaturas {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container_img_assinatura {
  width: 200px;
  height: 74px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.title-checklist,
.title-risk,
.title-medias,
.title-signature {
  font-size: 16px;
  color: #008144;
  font-family: 'Segoe UI';
  font-weight: bold;
  break-inside: avoid;
  break-before: avoid;
}
.lfAnalysis {
  display: flex;
  flex-direction: row;
}
.statusTemplate {
  font-size: 14px;
  font-weight: bold;
}
.analysisRisk{
  display: flex;
  align-items: center;
  flex-direction: row;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
  justify-content: space-between;
}
.lfAnalysisItens {
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
}
.analysisRiskItens{
  display: flex;
  align-items: initial;
  flex-direction: column;
  justify-content: initial;
}
.iconHat{
  background-color: #e8e8e8;
  border-radius: 5px;
}
.titleNumberApr{
  font-family: 'Segoe UI';
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.addressApr, .addressDiv{
  display: flex;
}

.responsableApr,
.dateExpire,
.dateApr {
  display: flex;
}

.dateResponsable{
  display: flex;
  gap: 1rem;
  justify-content: space-between;
}
.font-info {
  font-weight: bold;
}
.font-title, .font-info {
  font-family: 'Segoe UI';
  font-size: 14px;
}
.revisao{
  color: #008144;
  font-weight: bold;
  font-family: 'Segoe UI';
  font-size: 16px;
}
.numberApr, .numbreRevisao{
  display: flex;
  align-items: center;
}
.numbreRevisao {
  justify-content: flex-end;
}
.title-template,
/* .analysis-template, */
.container_ocorrencias,
.causa_raiza_result,
.title-signature,
.signaturelists{
  break-inside: avoid;
}
.checklist {
  break-after: avoid;
}
.checklistItens {
  break-after: avoid;
  border: 1px solid rgb(210, 210, 210);
}
.container-pdf{
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  border-radius: 10px;
  font-family: 'Segoe UI';
  font-weight: 500;
}
.title-template {
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  padding: 1rem;
  gap: 1rem;
  border-radius: 10px;
}
.info-pdf {
  display: flex;
}
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price {
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.header-title {
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover {
    background: #024d2a;
}
.button-cancel,
.button-save {
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.container_cancel_save {
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
}

.button-cancel {
  background-color: #b60000;
  color: white;
}
.button-save {
  background-color: darkgreen;
  color: white;
}
.size-logo-inco-pdf {
  height: 50px;
  width: 250px;
}
.pdf-header {
  margin-bottom: 1rem;
  height: 7vh;
  width: 100%;
  display: flex;
  align-items: center;
  padding-left: 25px;
  padding-right: 25px;
  background: #e4e5e6;
}
.conteiner_pdf_grafico{
      padding: 1rem;
}
.container_ocorrencias_filtradas {
  width: 100%;
  height: 2rem;
  border-radius: 5px 5px 0 0;
  background: #008144;
  display: flex;
  justify-content: space-around;
}
.font{
        color: #FFF;
        font-family:'Segoe UI';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .numero_oce,
    .tecnico_oce,
    .engenheiro_oce,
    .causa_raiza {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .numero_oce_result,
    .tecnico_oce_result,
    .engenheiro_oce_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .font_result {
        color: #1A1818;
        font-family:'Segoe UI';
        text-align: center;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 27px;
    }
    .container_ocorrencias {
      width: 100%;
      margin: 1rem 0;
      display: flex;
      justify-content: space-around;
    }
    .container_itens {
      width: 100%;
      display: flex;
      justify-content: initial;
    }
    .causa_raiza_result {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .icone-img {
      max-width: 6rem;
      max-height: 6rem;
    }

.assinatura-bloco-final {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  padding: 10px 30px 20px 30px;
  margin-top: auto;
  page-break-inside: avoid;
  background-color: white;
  width: 100%;
}

.coluna-esquerda {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 45%;
  text-align: left;
}

.coluna-direita {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 45%;
  text-align: right;
  margin-left: auto; /* força encostar na direita */
}

</style>



// WEBPACK FOOTER //
// src/views/private/apr/inqueryApr/components/inqueryTable/inqueryTable.vue